import {SearchRankTypeEnum} from '../enums';
import {UomCriteriaModel} from './uom-criteria.model';

export class AdvancedSearchFromSkuModel {
  attributeIds: string[];
  priceRank: SearchRankTypeEnum;
  uom: UomCriteriaModel;
  returnUrl: string;
}
